import { render, staticRenderFns } from "./onglets.vue?vue&type=template&id=59cd23c1"
import script from "./onglets.js?vue&type=script&lang=js&external"
export * from "./onglets.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports